import { get, post, put } from 'utils/methods';

export function getPartnersApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}partners`, data, headers);
}

export function addNewPartnerApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/partner`, data, headers);
}

export function addNewPartnerHolidaysApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/partner/holiday`, data, headers);
}

export function editPartnerHolidaysApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/partner/holiday`, data, headers);
}

export function editPartnerApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/partner`, data, headers);
}
